import { Directive, ElementRef, OnInit, Optional } from "@angular/core";
import { NgControl, NgModel } from "@angular/forms";

/*
extend FormControls with
    .nativeElement
    .focus()

must cast reference to <any> to access
        (<any>myFormControlRef).focus();
*/

@Directive({
    selector: '[ngModel], [formControl], [formControlName]'
})
export class NativeElementInjectorDirective implements OnInit {
    constructor(
        private element: ElementRef,
        private ngControl: NgControl,
        @Optional() private ngModel: NgModel
    ) { }

    ngOnInit() {
        let ctl: any;
        if (!!this.ngModel)
            ctl = this.ngModel.control as any;
        else
            ctl = this.ngControl.control as any;

        ctl.nativeElement = this.element.nativeElement;
        ctl.focus = () => {
            setTimeout(() => {
                this.element.nativeElement.focus();
                this.element.nativeElement.select();
            });
            return ctl;
        }
    }
}